<script>
import { useCheckoutProStore } from "@/store/checkout-pro";
import { useMagasinStore } from "@/store/magasin";
import { mapActions, mapState } from "pinia";

import OrderConfirmation from "@/components/organisms/order-confirmation/pro";

export default {
  components: {
    OrderConfirmation
  },
  props: {
    commande: {
      type: Object,
      required: true
    },
    merchHtml: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapState(useMagasinStore, { magasinName: "name", magasinId: "id" }),
    ...mapState(useCheckoutProStore, { commandeDetail: "commande" })
  },
  methods: {
    ...mapActions(useCheckoutProStore, {
      setStepValue: "setStepValue"
    })
  },
  created() {
    this.setStepValue(3);
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <OrderConfirmation
      v-if="commande"
      :commande="commande"
      :commande-detail="commandeDetail"
      :merch-html="merchHtml"
    />
  </div>
</template>
